import type { DrawOperation } from './types';
import type { IArtworkRenderer } from '../render/IArtworkRenderer';
import { sortBySeq } from './operations';

/**
 * Deterministic replay of the operation history into any IArtworkRenderer.
 *
 * Determinism guarantee: `replay(ops, r)` resets the renderer and applies the
 * operations strictly in seq order. Given the same operations, the sequence of
 * renderer calls is identical every time — independent of insertion order,
 * checkpoints, or viewport. This is what makes render caches safely disposable:
 * discarding a cache and replaying from scratch reproduces the same artwork.
 */
export function replay(ops: readonly DrawOperation[], renderer: IArtworkRenderer): void {
  renderer.reset();
  for (const op of sortBySeq(ops)) {
    renderer.apply(op);
  }
}
